var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_1217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.59619L20.7808 6.82294C21.0037 6.96794 21.1794 7.15869 21.3078 7.39519C21.4359 7.63169 21.5 7.88328 21.5 8.14994V18.6922C21.5 19.1974 21.325 19.6249 20.975 19.9749C20.625 20.3249 20.1974 20.4999 19.6923 20.4999H4.30775C3.80258 20.4999 3.375 20.3249 3.025 19.9749C2.675 19.6249 2.5 19.1974 2.5 18.6922V8.14994C2.5 7.88328 2.56408 7.63169 2.69225 7.39519C2.82058 7.15869 2.99625 6.96794 3.21925 6.82294L12 1.59619ZM12 12.6499L19.8 7.99994L12 3.34994L4.2 7.99994L12 12.6499ZM12 14.4037L4 9.62294V18.6922C4 18.782 4.02883 18.8558 4.0865 18.9134C4.14417 18.9711 4.21792 18.9999 4.30775 18.9999H19.6923C19.7821 18.9999 19.8558 18.9711 19.9135 18.9134C19.9712 18.8558 20 18.782 20 18.6922V9.62294L12 14.4037Z",
    fill: "#F7FAFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/Icons.71de86959134d543d66ffe31ee981fda.svg";
export { ForwardRef as ReactComponent };